import { enterprise_features, support_features } from 'data/Pricing/EntrpriseFeatures'
import React from 'react'

const EnterpriseFeatures = () => {
  return (
    <div className=" w-full grid grid-cols-1 md:grid-cols-2 gap-16  ">
      <div className=" hidden md:block">
        <img
          src="https://media.tradly.app/images/marketplace/39213/63646bfbbb5bde334da8f176_mohammad-rahmani-N5bT5RctFZ8-unsplash-p-1080-kwSpKrJV.webp"
          alt=""
          className=" rounded-r-lg"
        />
      </div>
      <div className=" w-full">
        <div className=" w-full flex flex-col  gap-3 md:gap-4  mb-8">
          <p className="  text-base  font-semibold text-primary">Scale</p>
          <h2 className="h2 mx-auto md:mx-0">Grow with confidence</h2>
          <p className=" text-lightGray text-[18px] font-medium  leading-[27px] max-w-screen-md mr-0">
            Tradly Enterprise is uniquely suited to the needs of large communities while ensuring
            stellar customer experience.
          </p>
        </div>

        <div className=" grid  grid-cols-1 md:grid-cols-2    gap-x-8  gap-y-10 md:gap-y-12">
          {enterprise_features.map((feature) => {
            return (
              <div className=" flex items-start justify-start   flex-col p-[10px] pl-[14px] ">
                <div className=" mb-6 flex items-center justify-center text-primary h-10 w-10 bg-primary/40  ring-8 ring-primary/10  rounded-full ">
                  {feature.icon}
                </div>
                <h4 className=" h4  mb-2">{feature.title} </h4>
                <p className="text-lightGray text-base font-medium  leading-[24px]">
                  {feature.description}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default EnterpriseFeatures
